import { fg } from '@atlassian/jira-feature-gating';

const JsmSurfaceAgentAssigneeRelayProvider = {
	get(): boolean {
		return fg('jsm-surface-agent-assignee');
	},
};

export default JsmSurfaceAgentAssigneeRelayProvider;
